import { createStore } from '@store/createStore';

const filterInitialState = {
  search: '',
  location: { id: 'all', name: 'All' },
  showIncludedTemplate: false,
  selectedRows: new Map(),
};

const useManageTemplateFilterStore = createStore((set) => ({
  ...filterInitialState,
  actions: {
    setManageTemplateFilterInitialState: () => set({ ...filterInitialState }),
    setManageTemplateFilterSearchValue: (search) => set({ search }),
    setManageTemplateFilterLocationValue: (location) => set({ location }),
    setManageTemplateFilterShowIncludedTemplateValue: (showIncludedTemplate) => set({ showIncludedTemplate }),
    setManageTemplateFilterSelectedRows: (selectedRows) => set({ selectedRows }),
  },
}));

export const useManageTemplateFilterActions = () => useManageTemplateFilterStore((state) => state.actions);

export const selectManageTemplateFilterSearchValue = () =>
  useManageTemplateFilterStore((state) => state.search);
export const selectManageTemplateFilterLocationValue = () =>
  useManageTemplateFilterStore((state) => state.location);
export const selectManageTemplateFilterShowIncludedTemplateValue = () =>
  useManageTemplateFilterStore((state) => state.showIncludedTemplate);
export const selectManageTemplateFilterSelectedRows = () =>
  useManageTemplateFilterStore((state) => state.selectedRows);
